<template>
    <h6 class="dropdown-header">
        <slot/>
    </h6>
</template>